import {Lang} from 'yougile-lang'
import {PermissionsChecker} from '@client/permissions-checker'
import {
  showDeleteConfirm
} from '@components/common/base/notifications'
import {MessageBox} from '@components/message-box'
import {PageService} from '@extensions/page-service'
import {stickerCtl} from '@extensions/sticker/sticker'
import {HandlerProps} from './types'

const stringCtl = stickerCtl.String

type UseActionHandlersRet = {
  edit: () => void
  del: () => void
}

export const useActionHandlers = (
  props: HandlerProps
): UseActionHandlersRet => {
  const {stringStickerState, store, state} = props
  const edit = (): void => {
    const board = PageService.getCurrentBoard()
    if (!PermissionsChecker.checkEditBoardStickers(board)) {
      MessageBox.warn(Lang.msg.permission.noEditObject)
    } else {
      if (state.sticker) {
        store.setStringState(
          stringCtl.getState(state.sticker, stringStickerState.id)
        )
      }
      store.setEditCurrentState(true)
      store.setStringStateName(state.stringState?.name || '')
    }
  }

  const del = async (): Promise<void> => {
    const board = PageService.getCurrentBoard()
    if (!PermissionsChecker.checkEditBoardStickers(board)) {
      MessageBox.warn(Lang.msg.permission.noEditObject)
    } else {
      if (await showDeleteConfirm(Lang.msg.confirmStickerStateDelete)) {
        if (state.sticker) {
          stringCtl.removeState(state.sticker, stringStickerState.id)
          store.setStringStates(stringCtl.listStates(state.sticker))
        }
        store.setStickerChanged(true)
      }
    }
  }

  return {edit, del}
}
